// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K-8B","largestCol":"styles_largestCol__1EvxL","smallestCol":"styles_smallestCol__12mD7"};